import apiRoutes from '../../../api-routes';
import { useMutationWithLogout } from '../../../hooks/useMutationWithLogout';
import { getRequest } from '../../../helpers/apiClient';
import { standardDateFormat } from '../../../helpers/standardDateFormat';
import download from 'downloadjs';
import { parseAnalitycsFullFilters } from '../helpers/parseAnalitycsFullFilters';

export const useDownloadAnalyticsReport = (options) =>
  useMutationWithLogout(
    async (filters) => {
      const { data } = await getRequest({
        url: apiRoutes.DOCUMENTS_REPORT_FILE_DOWNLOAD,
        responseType: 'arraybuffer',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
        params: parseAnalitycsFullFilters(filters),
      });
      return data;
    },
    {
      ...options,
      onSuccess: (response) => {
        const prefix = standardDateFormat();
        const blob = new Uint8Array(response);
        download(blob, `analytics-report-${prefix}.xlsx`, 'text/csv');
      },
    },
  );
